<template>
    <v-card class="pa-4">
        <v-row no-gutters>
            <v-col
                :cols="$vuetify.breakpoint.smAndDown ? '12' : '7'"
                class="pr-1"
            >
                <v-card outlined class="px-4">
                    <v-row>
                        <v-col md="12" class="mb-1 mt-1">
                            <h4
                                class="font-weight-light primary--text"
                                :class="
                                    $vuetify.breakpoint.smAndDown
                                        ? 'text-center'
                                        : ''
                                "
                            >
                                Datos
                            </h4>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row
                        :class="
                            $vuetify.breakpoint.smAndDown
                                ? 'pa-2 py-0 mb-2'
                                : 'mb-n7'
                        "
                    >
                        <v-col
                            :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'"
                        >
                            <v-text-field
                                v-model="Name"
                                label="Nombre"
                                style="padding: 21.1px 0px 17px 0px"
                            ></v-text-field>
                        </v-col>
                        <v-col
                            :cols="$vuetify.breakpoint.smAndDown ? '12' : '3'"
                            :class="$vuetify.breakpoint.smAndDown ? 'py-0' : ''"
                        >
                            <v-select
                                clearable
                                hide-selected
                                chips
                                :items="opciones.tarifas.segment"
                                item-value="encoded"
                                item-text="human"
                                v-model="SelectedSegment"
                                label="Segmento"
                            >
                                <template #selection="{ item }">
                                    <v-chip
                                        color="yellow darken-2"
                                        class="white--text"
                                    >
                                        {{ item.human }}
                                        <v-icon> mdi-call-merge </v-icon>
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col
                            :cols="$vuetify.breakpoint.smAndDown ? '12' : '3'"
                            :clas="$vuetify.breakpoint.smAndDown ? 'px-0' : ''"
                        >
                            <v-select
                                clearable
                                chips
                                :items="opciones.tarifas.operator"
                                item-value="encoded"
                                item-text="human"
                                v-model="Operator"
                                :label="Operator ? Operator : 'Operador'"
                            >
                                <template #selection="{ item }">
                                    <v-chip color="primary" class="white--text">
                                        <v-icon> mdi-signal-variant </v-icon>
                                        {{ item.human }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col
                :cols="$vuetify.breakpoint.smAndDown ? '12' : '5'"
                :class="$vuetify.breakpoint.smAndDown ? 'py-2' : ''"
            >
                <v-card outlined class="px-4 pb-1">
                    <v-row>
                        <v-col md="7" class="mb-1 mt-1">
                            <h4 class="font-weight-light primary--text">
                                Tiempo de Permanencia
                            </h4>
                        </v-col>
                        <v-col md="5" class="mb-1 mt-1">
                            <h4 class="font-weight-light primary--text">
                                Precio del Servicio
                            </h4>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row class="mb-n7">
                        <v-col md="3" cols="6">
                            <v-text-field
                                v-model="Permanence"
                                label="Tiempo"
                                required
                                style="padding: 21.1px 0px 12px 0px"
                            ></v-text-field>
                        </v-col>
                        <v-col
                            md="4"
                            cols="6"
                            style="padding: 21px 10px 0px 10px"
                        >
                            <v-select
                                hide-selected
                                :items="['Months']"
                                disabled
                                label="Unidad"
                                v-model="permanenceTime"
                            ></v-select>
                        </v-col>
                        <v-col md="3">
                            <v-text-field
                                :disabled="formType != 'add'"
                                v-model="Price"
                                label="Cantidad"
                                required
                                style="padding: 21.1px 0px 12px 0px"
                            ></v-text-field>
                        </v-col>
                        <v-col md="2" style="padding: 21px 10px 0px 10px">
                            <v-select
                                hide-selected
                                :items="['€']"
                                disabled
                                label="Unidad"
                                v-model="priceUnit"
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-row no-gutters class="pt-1">
            <v-col md="12" cols="12">
                <v-card outlined class="px-4 pb-1">
                    <v-row>
                        <v-col md="12" class="mb-1 mt-1">
                            <h4 class="font-weight-light primary--text">
                                Promociones
                            </h4>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row class="mb-n4">
                        <v-col cols="12">
                            <v-autocomplete
                                clearable
                                multiple
                                chips
                                :items="filteredPromotions"
                                item-text="id"
                                v-model="SelectedPromotions"
                                label="Promociones"
                            >
                                <template #selection="{ item }">
                                    <v-chip
                                        @click:close="removePromo(item)"
                                        close
                                        color="pink"
                                        class="white--text"
                                    >
                                        <v-icon> mdi-credit-card </v-icon>
                                        {{ item.name ? item.name : item.id }}
                                    </v-chip>
                                </template>
                                <template #item="{ item }">
                                    <v-row>
                                        <v-col cols="11">
                                            {{
                                                item && item.name
                                                    ? item.name
                                                    : item.id
                                            }}
                                        </v-col>
                                        <v-col cols="1">
                                            <v-icon
                                                :color="
                                                    item.is_active
                                                        ? 'green'
                                                        : 'red'
                                                "
                                            >
                                                mdi-circle
                                            </v-icon>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'SVAManagementForm',
    data: () => ({
        priceUnit: '€',
        permanenceTime: 'Months',
        autoUpfront: true,
    }),
    methods: {
        removePromo(item) {
            let index = this.SelectedPromotions.indexOf(item.id);
            this.SelectedPromotions.splice(index, 1);
        },
        clearFields() {
            this.$store.state.ManagementBase.SVAManagement.Name = '';
            this.$store.state.ManagementBase.SVAManagement.Operator = '';
            // this.$store.state.ManagementBase.SVAManagement.Brand = '';
            this.$store.state.ManagementBase.SVAManagement.Upfront = 0;
            this.$store.state.ManagementBase.SVAManagement.FamiliaObjetivo = 0;
            this.$store.state.ManagementBase.SVAManagement.Permanence = '';
            this.$store.state.ManagementBase.SVAManagement.Price = '';
            this.$store.state.ManagementBase.SVAManagement.IsActive = false;
            this.$store.state.ManagementBase.SVAManagement.SelectedPromotions =
                [];
        },
        closeForm() {
            this.$store.commit(
                'ManagementBase/SVAManagement/isOpenDialog',
                false
            );
            this.clearFields();
        },
        submitSVA() {
            if (
                this.$store.state.ManagementBase.SVAManagement.formType == 'add'
            )
                this.$store.dispatch('ManagementBase/SVAManagement/addSva');
            else this.$store.dispatch('ManagementBase/SVAManagement/editSva');

            this.closeForm();
        },
    },
    computed: {
        filteredPromotions() {
            let filterIs_active = (item) => (item.is_active = true);
            let filterOperator = (item) =>
                this.operator ? item.operator == this.operator : true;

            return this.promotions.filter(
                (item) => filterIs_active(item) && filterOperator(item)
            );
        },
        isOpenDialog: {
            get() {
                return this.$store.state.ManagementBase.SVAManagement
                    .isOpenDialog;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/SVAManagement/isOpenDialog',
                    val
                );
                this.clearFields();
            },
        },
        SelectedPromotions: {
            get() {
                return this.$store.state.ManagementBase.SVAManagement.SelectedPromotions.map(
                    (promotion) => promotion.id
                );
            },
            set(discountIds) {
                this.$store.state.ManagementBase.SVAManagement.SelectedPromotions =
                    [];

                discountIds.forEach((discountId) => {
                    this.$store.state.ManagementBase.SVAManagement.SelectedPromotions.push(
                        this.promotions.find(
                            (promotion) => promotion.id == discountId
                        )
                    );
                });
            },
        },
        Name: {
            get() {
                return this.$store.state.ManagementBase.SVAManagement.Name;
            },
            set(val) {
                this.$store.commit('ManagementBase/SVAManagement/Name', val);
            },
        },
        Operator: {
            get() {
                return this.$store.state.ManagementBase.SVAManagement.Operator;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/SVAManagement/Operator',
                    val
                );
            },
        },
        // Brand: {
        //     get() {
        //         return this.$store.state.ManagementBase.SVAManagement.Brand;
        //     },
        //     set(val) {
        //         this.$store.commit('ManagementBase/SVAManagement/Brand', val);
        //     },
        // },
        Permanence: {
            get() {
                return this.$store.state.ManagementBase.SVAManagement
                    .Permanence;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/SVAManagement/Permanence',
                    val
                );
            },
        },
        Price: {
            get() {
                return this.$store.state.ManagementBase.SVAManagement.Price;
            },
            set(val) {
                this.$store.commit('ManagementBase/SVAManagement/Price', val);
            },
        },
        Upfront: {
            get() {
                return this.$store.state.ManagementBase.SVAManagement.Upfront;
            },
            set(val) {
                this.$store.commit('ManagementBase/SVAManagement/Upfront', val);
            },
        },
        FamiliaObjetivo: {
            get() {
                return this.$store.state.ManagementBase.SVAManagement
                    .FamiliaObjetivo;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/SVAManagement/FamiliaObjetivo',
                    val
                );
            },
        },
        IsActive: {
            get() {
                return this.$store.state.ManagementBase.SVAManagement.IsActive;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/SVAManagement/IsActive',
                    val
                );
            },
        },
        isEditableForm() {
            return this.formType == 'edit' || this.formType == 'watch';
        },
        SelectedSegment: {
            get() {
                return this.$store.state.ManagementBase.SVAManagement
                    .SelectedSegment;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/SVAManagement/SelectedSegment',
                    val
                );
            },
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        ...mapState('ManagementBase', {
            tipoObjetivo: (state) => state.tipoObjetivo,
            formType: (state) => state.baseForm.formType,
        }),
        ...mapState('ManagementBase/promotionManagement', {
            promotions: (state) => state.promotionManagement.promotions,
        }),
    },
};
</script>
